import { MInput } from "components/forms";
import { dateHelper, learningService, lessonSectionService, networkErrorHelper, stringHelper } from "libs";
import { Button, Container, Col, Row } from "design-react-kit";
import React, { Component } from "react";
import { MTable } from "components/table";
import { MnemoCallout, MnemoLoading, MnemoModal, ModalHandler, MSection, Title } from "components/misc";
import { withRouter } from "react-router-dom";
import { AdminLessonResumeForm } from "components/forms/admin";

class LessonStudentAnalytics extends Component {
  state = {
    loading: false,
    loadingError: false,
    rndKey: 0,
    rCode: "",
    user: null,
    course: null,
    userCourse: null,
    analytics: [],
    missing: [],
    viewMode: "attended", //attended or missing
    hasSearched: false,
    error: null,
    isAddOpen: false,
  };

  componentDidMount() {
    const { registrationCode } = this.props.match.params;

    if (registrationCode) {
      this.setState({ rCode: registrationCode });
      this.loadUserCourse(registrationCode);
    }
  }

  loadUserCourse = (rCode) => {
    this.setState({ loading: true });
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { user, course, userCourse } = data.payload;

        this.setState({
          user,
          course,
          userCourse,
        });

        this.loadRemote(rCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  };

  loadRemote = (rCode) => {
    lessonSectionService
      .getAnalyticsStudent(rCode)
      .then(({ data }) => {
        let analytics = data.payload.analytics;
        analytics = analytics.filter((row) => row.lessonId != null);
        const lessons = data.payload.lessons;

        const missing = lessons.filter((l) => {
          const hasAttended = analytics.some((a) => a.lessonId === l.id && a.lessonType === l.lessonType);
          return !hasAttended;
        });

        this.setState({
          loading: false,
          analytics,
          missing,
          hasSearched: true,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
        this.setState({
          loading: false,
          loadingError: true,
        });
      });
  };

  getLessonType = (type) => {
    switch (type) {
      case "live":
        return "Online";
      case "onsite":
        return "In presenza";
      case "training":
        return "Tirocinio";
      default:
        return type;
    }
  };

  handleDetail = (e, value, row) => {
    if (!row) return;
    if (row.mode === "attivita") return;

    const { lessonType, lessonId, mode, date } = row;
    const { rCode } = this.state;

    const type = this.getLessonType(lessonType);
    const modalTitle = `Frequenza lezione ${type} del ${dateHelper.toITDate(date)}`;

    lessonSectionService
      .getAnalyticsDetail(rCode, lessonType, lessonId, mode)
      .then(({ data }) => {
        const detail = data.payload.detail;
        const config = this.getDetailTableConfig(lessonType, mode);

        ModalHandler.show(null, modalTitle, <MTable tableData={detail} tableConfig={config} />, () => {}, null, "", "Chiudi", false, true);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
      });
  };

  handleAdd = () => {
    this.setState({ isAddOpen: true });
  };

  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "lessonId", // accessor is the "key" in the data
      },
      {
        id: "description",
        Header: "Descrizione",
        accessor: (row) => {
          let description = [];

          description.push(this.getLessonType(row.lessonType));
          if (row.analyticsType) description.push(stringHelper.capitalizeFirstLetter(row.analyticsType));
          if (row.note) description.push(row.note);
          if (row.mode) description.push(stringHelper.capitalizeFirstLetter(row.mode));

          return (
            <>
              {description.map((d, i) => (
                <div key={i} className={i < description.length - 1 ? "mb-1" : ""}>
                  {d}
                </div>
              ))}
            </>
          );
        },
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDate(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart ? row.hourStart.substring(0, row.hourStart.length - 3) : "";
        },
      },
      {
        id: "hourEnd",
        Header: "Ora fine",
        accessor: (row) => {
          return row.hourEnd ? row.hourEnd.substring(0, row.hourEnd.length - 3) : "";
        },
      },
      {
        id: "section",
        Header: "Sezione",
        accessor: (row) => (row.sectionTitle ? `${row.section} - ${row.sectionTitle}` : row.section),
      },
      {
        id: "minutes",
        Header: "Minuti frequenza",
        accessor: "minutes",
      },
      {
        id: "total",
        Header: "Minuti totali",
        accessor: "total",
      },
    ],
    actions: [
      {
        id: "detail",
        hidden: (row) => row.mode === "attivita" || ["studio individuale", "elaborato di recupero"].includes(row.analyticsType),
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: this.handleDetail,
      },
    ],
  };

  missingTableConfig = {
    columns: [
      {
        id: "id",
        Header: "Column 0",
        isVisible: false,
        accessor: "id",
      },
      {
        id: "description",
        Header: "Descrizione",
        accessor: (row) => {
          let description = [];

          if (row.lessonType) description.push(this.getLessonType(row.lessonType));
          if (row.mode) description.push(stringHelper.capitalizeFirstLetter(row.mode));

          return (
            <>
              {description.map((d, i) => (
                <div key={i} className={i < description.length - 1 ? "mb-1" : ""}>
                  {d}
                </div>
              ))}
            </>
          );
        },
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => (row.date ? dateHelper.toITDate(row.date) : ""),
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => (row.hourStart ? row.hourStart.substring(0, 5) : ""),
      },
      {
        id: "hourEnd",
        Header: "Ora fine",
        accessor: (row) => (row.hourEnd ? row.hourEnd.substring(0, 5) : ""),
      },
      {
        id: "section",
        Header: "Sezione",
        accessor: (row) => (row.sectionTitle ? `${row.section} - ${row.sectionTitle}` : row.section),
      },
    ],
    actions: [],
  };

  getDetailTableConfig(lessonType, mode) {
    let type = lessonType;
    if (lessonType === "training") {
      type = mode === "online" ? "live" : mode === "presenza" ? "onsite" : lessonType;
    }

    if (type === "live") {
      return {
        columns: [
          {
            id: "email",
            Header: "Email",
            accessor: "email",
          },
          {
            id: "connectionType",
            Header: "Tipo Connessione",
            accessor: "connectionType",
          },
          {
            id: "login",
            Header: "Ingresso",
            accessor: (row) => (row.login ? dateHelper.toITDateTime(row.login) : "-"),
          },
          {
            id: "logout",
            Header: "Uscita",
            accessor: (row) => (row.logout ? dateHelper.toITDateTime(row.logout) : "-"),
          },
          {
            id: "duration",
            Header: "Minuti",
            accessor: "duration",
          },
        ],
        actions: [],
      };
    } else if (type === "onsite") {
      return {
        columns: [
          {
            id: "login",
            Header: "Ingresso",
            accessor: (row) => (row.login ? dateHelper.toITDateTime(row.login) : "-"),
          },
          {
            id: "logout",
            Header: "Uscita",
            accessor: (row) => (row.logout ? dateHelper.toITDateTime(row.logout) : "-"),
          },
          {
            id: "duration",
            Header: "Minuti",
            accessor: "duration",
          },
        ],
        actions: [],
      };
    }

    return { columns: [], actions: [] };
  }

  onChange = (id, value) => {
    this.setState({ rCode: value });
  };

  render() {
    const { loading, rndKey, rCode, user, course, userCourse, isAddOpen, analytics, missing, hasSearched, viewMode } = this.state;

    return (
      <div className="container">
        <Title>Statistiche frequenza studente</Title>
        <Container className="mt-3">
          <Row>
            <Col md="4">
              <MInput id="registrationCode" label="Codice Registrazione" value={rCode} onChange={this.onChange} />
            </Col>
            <Col md="2">
              <Button color="primary bg-dark" className="ml-2" onClick={() => this.loadUserCourse(this.state.rCode)}>
                Cerca
              </Button>
            </Col>
          </Row>
        </Container>
        {loading ? (
          <MnemoLoading />
        ) : (
          hasSearched && (
            <>
              <MnemoCallout className="mnemo-callout-success mb-4">
                <Row>
                  <Col md={8}>
                    <b>Nome</b>: {user.name}
                    <br />
                    <b>Cognome</b>: {user.surname}
                    <br />
                    <b>Email</b>: {user.email}
                    <br />
                    <b>Titolo corso</b>: {course.title}
                    <br />
                    <b>Codice corso</b>: {course.code}
                  </Col>
                </Row>
              </MnemoCallout>

              <Container>
                <Row className="my-4 text-center">
                  <Col>
                    <Button color={viewMode === "attended" ? "secondary" : "primary bg-dark"} onClick={() => this.setState({ viewMode: "attended" })}>
                      Lezioni Frequentate
                    </Button>
                  </Col>
                  <Col>
                    <Button color={viewMode === "missing" ? "secondary" : "primary bg-dark"} onClick={() => this.setState({ viewMode: "missing" })}>
                      Lezioni Non Frequentate / Future
                    </Button>
                  </Col>
                </Row>
              </Container>

              {viewMode === "attended" ? (
                <MSection className="my-4">
                  <h4 className="mb-1">Frequentate</h4>
                  <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button color="primary bg-dark" onClick={this.handleAdd}>
                      Aggiungi attività
                    </Button>
                  </div>

                  {analytics && analytics.length > 0 ? (
                    <MTable key={rndKey} tableData={analytics} tableConfig={this.tableConfig} />
                  ) : (
                    <p>Nessun dato di frequenza disponibile per questo studente.</p>
                  )}
                </MSection>
              ) : (
                <MSection className="my-4">
                  <h4 className="mb-3">Non Frequentate / Future</h4>
                  {missing && missing.length > 0 && <MTable key={`missing-${rndKey}`} tableData={missing} tableConfig={this.missingTableConfig} />}
                </MSection>
              )}
            </>
          )
        )}

        {isAddOpen && (
          <MnemoModal
            show={isAddOpen}
            title="Aggiungi attività"
            showCancel={false}
            showConfirm={false}
            onCancel={() => this.setState({ isAddOpen: false })}
            content={
              course &&
              userCourse && (
                <AdminLessonResumeForm
                  aa={userCourse.aa}
                  userId={userCourse.userId}
                  email={user.email}
                  courseCode={course.code}
                  courseType={course.courseType}
                  analyticsType="elaborato di recupero"
                  registrationCode={rCode}
                  onCancel={() => this.setState({ isAddOpen: false })}
                  onSuccess={() => {
                    this.setState({ isAddOpen: false, loading: true });
                    this.loadRemote(rCode);
                  }}
                />
              )
            }
          />
        )}
      </div>
    );
  }
}

export default withRouter(LessonStudentAnalytics);
